var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"d-flex align-center direction-column",class:{ 'direction-md-row': !_vm.isVertical }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }